import { render, staticRenderFns } from "./ManageForm6.vue?vue&type=template&id=5c5ced3e&"
import script from "./ManageForm6.vue?vue&type=script&lang=js&"
export * from "./ManageForm6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports